import React, { Suspense, useCallback, useEffect, lazy } from 'react';
import styled from 'styled-components';

import { lazyWithPreload } from '../../utilities/lazy-with-preload';
import Loader, { LoaderWrapper } from '../common/Loader';
import { useAppContext } from '../../context';
import { useNavigation } from '../../context';
import { contentPaddingSides } from '../../common/styles';
import { useWorkspace } from '../../context';
import { smallElevationShadow } from '../../common/styles';
import NavbarWrapper from '../common/navigation/NavbarWrapper';
import FloatingBottom from './FloatingBottom';
import RightPanel from './RightPanel';
import Drawer from './Drawer';

const ToolTabs = styled.div`
    padding-left: ${contentPaddingSides};
    padding-right: ${contentPaddingSides};
    background-color: white;
    width: 100%;
    overflow: hidden;
    box-shadow: ${smallElevationShadow};
    position: relative;
`

const FloatingBottomPlaceholder = styled.div`
    height: 56px;
    width: 100%;
`;
const DrawerPlaceholder = styled.div`
    height: 50px;
    width: 100%;
`;

const Workspace = lazyWithPreload(() => import(/* webpackChunkName: 'Workspace'  */ './Workspace'));
const WorkspaceProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'WorkspaceProvider' */ '../../providers/WorkspaceProvider').then((module) => ({
        default: module.WorkspaceProvider,
    }))
);

const Composer = ({
    compositionModelRef,
    stats,
    workspaceRef,
    workspaceToolsSectionRef,
    workspaceMessagesSectionRef
}) => {
    const { isMobile } = useAppContext();
    const { tabContent, openModelViewer } = useNavigation();
    const { mobileToolbar, setCompositionModelLoaded, setIsExportingGLTF, isExportingGLTF } = useWorkspace();

    useEffect(() => {
        WorkspaceProvider.preload();

    }, [isMobile]);

    const compositionModelCallbackRef = useCallback((node) => {
        if (node !== null) {
            compositionModelRef.current = node;
            setCompositionModelLoaded(true);
        }
    }, []);

    return (
        <>
            {(openModelViewer || isExportingGLTF) && (
                <LoaderWrapper style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <Loader />
                </LoaderWrapper>
            )}
            {/*<Suspense fallback={<Loader />}>*/}
            <Workspace
                workspaceRef={workspaceRef}
                compositionModelCallbackRef={compositionModelCallbackRef}
                workspaceToolsSectionRef={workspaceToolsSectionRef}
                workspaceMessagesSectionRef={workspaceMessagesSectionRef}
                visible={!openModelViewer && !isExportingGLTF}
                stats={stats}
            />
            {/*</Suspense>*/}
            {!openModelViewer &&
                !isExportingGLTF &&
                (isMobile ? (
                    <>
                        <ToolTabs>
                            {mobileToolbar}
                            {tabContent}
                        </ToolTabs>

                        <NavbarWrapper />
                        <Suspense fallback={<DrawerPlaceholder/>}>
                            <Drawer />
                        </Suspense>
                        
                        <Suspense fallback={<FloatingBottomPlaceholder/>}>
                            <FloatingBottom />
                        </Suspense>
                    </>
                ) : (
                    <RightPanel>
                        {tabContent}
                    </RightPanel>

                ))}

        </>
    );
};

export default Composer;
